export default __webpack_public_path__ + "static/media/bellIconBlack.87d9afd8.svg";